import { CognitoAuth, StorageHelper } from "amazon-cognito-auth-js";
import IndexRouter from "@/router/index";
import AuthInfo from "@/api/auth-info.js";
import store from "@/store";

// see the .env file for
const CLIENT_ID = process.env.VUE_APP_COGNITO_CLIENT_ID;
const APP_DOMAIN = process.env.VUE_APP_COGNITO_APP_DOMAIN;
const REDIRECT_URI = process.env.VUE_APP_COGNITO_REDIRECT_URI;
const USERPOOL_ID = process.env.VUE_APP_COGNITO_USERPOOL_ID;
const REDIRECT_URI_SIGNOUT = process.env.VUE_APP_COGNITO_REDIRECT_URI_SIGNOUT;

var authData = {
  ClientId: CLIENT_ID, // Your client id here
  AppWebDomain: APP_DOMAIN,
  TokenScopesArray: ["openid", "email", "profile"],
  RedirectUriSignIn: REDIRECT_URI,
  RedirectUriSignOut: REDIRECT_URI_SIGNOUT,
  UserPoolId: USERPOOL_ID,
};

var auth = new CognitoAuth(authData);
auth.userhandler = {
  onSuccess: function() {
    store.commit("setLoggedIn");
    AuthInfo.getUserInfo().then((response) => {
      store.commit("setCognitoInfo", response);
    });
  },
  onFailure: function(err) {
    store.commit("setLoggedOut");
    IndexRouter.go({
      path: "/error",
      query: { message: "Login failed due to " + err },
    });
  },
};

function getUserInfoStorageKey() {
  var keyPrefix = "CognitoIdentityServiceProvider." + auth.getClientId();
  var tokenUserName = auth.signInUserSession.getAccessToken().getUsername();
  var userInfoKey = keyPrefix + "." + tokenUserName + ".userInfo";
  return userInfoKey;
}

var storageHelper = new StorageHelper();
var storage = storageHelper.getStorage();

export default {
  auth: auth,
  login() {
    auth.getSession();
  },
  logout() {
    if (auth.isUserSignedIn()) {
      auth.signOut();
      storage.clear();
    }
  },
  isUserSignedIn() {
    // TODO: if accesstoken is expired use the refesh token to get new access token
    // if (!auth.isUserSignedIn()) {
    // var refreshToken = auth.getSignInUserSession().getRefreshToken().getToken();
    // return false;
    // auth.refreshSession();
    // }
    return auth.isUserSignedIn();
  },
  isUserAuthorized(restrictions = undefined) {
    if (restrictions === undefined || restrictions.length == 0) {
      return true;
    } else {
      // turn all restrictions into arrays
      if (!Array.isArray(restrictions)) restrictions = [restrictions];

      // admins have access to everything
      if (store.getters.userGroups?.includes("admin")) return true;

      // check if the user groups are within the restrictions
      return restrictions.some((x) => store.getters.userGroups?.includes(x));
    }
  },
  isThirdPartyRestricted(){
    if (store.getters.userGroups?.includes("admin")) return false;
    return this.isUserAuthorized(['third-party']);
  },
  /**
   * Used to determine whether some functionalities should be denied for certain groups.
   * 
   * Admins should be allowed to perform any actions.
   */
  denyFor(groups = undefined) {
    if (store.getters.userGroups?.includes("admin")) {
      return false
    };

    if (groups === undefined) {
      return true;
    }

    if (! Array.isArray(groups)) {
      groups = [groups];
    }

    return groups.some((group) => store.getters.userGroups?.includes(group));
  },
  getUserInfoStorageKey,
};
